import {
  type Features,
  showFeature as showFeatureUtil,
} from '@seek/ca-myprofile-utils';

import { getUnifiedSiteStatus } from 'src/modules/utils';

import type { AppConfig, AppConfigParam } from '../types';

export const getAppConfig = ({
  site,
  zone,
  brand,
  locale,
  language,
}: AppConfigParam): AppConfig => {
  const isUnifiedSite = getUnifiedSiteStatus(site);
  return {
    brand,
    language,
    locale,
    zone,
    site,
    isUnifiedSite,
    showFeature: (feature: keyof Features) =>
      showFeatureUtil(feature, zone, language, isUnifiedSite),
  };
};
